import { render } from "./OapDsfAppSkindrWrapper.vue?vue&type=template&id=d793dd2e&scoped=true"
import script from "./OapDsfAppSkindrWrapper.vue?vue&type=script&lang=js"
export * from "./OapDsfAppSkindrWrapper.vue?vue&type=script&lang=js"

import "./OapDsfAppSkindrWrapper.vue?vue&type=style&index=0&id=d793dd2e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d793dd2e"]])

export default __exports__